export const DEFAULT_ENTRY_COLOR = '#BCC2D1';

export const MINIMUM_ENTRY_MESSAGE_RELATIVE_MINUTES = 15;
